<template>
  <div class="right-content">
    <div class="notice-page">
      <div class="page-header">
        <h3>消息通知</h3>
        <div class="header-actions">
          <el-radio-group v-model="filterType" size="small" @change="handleFilterChange">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="0">未读</el-radio-button>
            <el-radio-button label="1">已读</el-radio-button>
          </el-radio-group>
          <el-button 
            v-if="unreadCount > 0" 
            type="primary" 
            size="small" 
            @click="handleMarkAllRead"
            :loading="markingAll"
          >
            全部标记已读
          </el-button>
        </div>
      </div>

      <div v-loading="loading" class="notice-list">
        <div v-if="list.length === 0 && !loading" class="empty-tip">
          <el-empty description="暂无消息通知" />
        </div>
        <div 
          v-for="item in list" 
          :key="item.id" 
          class="notice-item"
          :class="{ 'is-unread': item.is_read === 0 }"
          @click="handleItemClick(item)"
        >
          <div class="notice-icon">
            <el-badge :is-dot="item.is_read === 0" type="danger">
              <svg viewBox="0 0 24 24" width="24" height="24" :fill="getIconColor(item.level)">
                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"/>
              </svg>
            </el-badge>
          </div>
          <div class="notice-content">
            <div class="notice-header">
              <span class="notice-title">{{ item.title }}</span>
              <el-tag 
                v-if="item.level_text" 
                :type="getLevelType(item.level)" 
                size="small"
              >
                {{ item.level_text }}
              </el-tag>
            </div>
            <div class="notice-text">{{ item.content }}</div>
            <div class="notice-footer">
              <span class="notice-type">{{ item.type_text }}</span>
              <span class="notice-time">{{ item.create_time }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="total > 0" class="pagination">
        <el-pagination
          v-model:current-page="page"
          v-model:page-size="pagesize"
          :total="total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import notice from "@/api/notice";

export default {
  name: "my_notice",
  data() {
    return {
      loading: false,
      markingAll: false,
      list: [],
      page: 1,
      pagesize: 10,
      total: 0,
      filterType: '',
      unreadCount: 0,
    };
  },
  created() {
    this.fetchList();
    this.fetchUnreadCount();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          pagesize: this.pagesize,
        };
        if (this.filterType !== '') {
          params.is_read = parseInt(this.filterType);
        }
        const res = await notice.myList(params);
        if (res && res.data) {
          this.list = res.data.data || [];
          this.total = res.data.total || 0;
        }
      } catch (err) {
        this.$message.error(err.msg || '获取通知列表失败');
      } finally {
        this.loading = false;
      }
    },
    async fetchUnreadCount() {
      try {
        const res = await notice.unreadCount();
        if (res && res.data) {
          this.unreadCount = res.data.count || 0;
        }
      } catch (err) {
        console.error('获取未读数量失败', err);
      }
    },
    handleFilterChange() {
      this.page = 1;
      this.fetchList();
    },
    handlePageChange() {
      this.fetchList();
    },
    handleSizeChange() {
      this.page = 1;
      this.fetchList();
    },
    async handleItemClick(item) {
      if (item.is_read === 0) {
        try {
          await notice.markRead({ id: item.id });
          item.is_read = 1;
          this.fetchUnreadCount();
        } catch (err) {
          console.error('标记已读失败', err);
        }
      }
      if (item.jump_url) {
        window.open(item.jump_url, '_blank');
      }
    },
    async handleMarkAllRead() {
      this.markingAll = true;
      try {
        await notice.markAllRead();
        this.$message.success('已全部标记为已读');
        this.fetchList();
        this.fetchUnreadCount();
      } catch (err) {
        this.$message.error(err.msg || '操作失败');
      } finally {
        this.markingAll = false;
      }
    },
    getIconColor(level) {
      const colors = {
        0: '#909399',
        1: '#E6A23C',
        2: '#F56C6C',
      };
      return colors[level] || '#909399';
    },
    getLevelType(level) {
      const types = {
        0: 'info',
        1: 'warning',
        2: 'danger',
      };
      return types[level] || 'info';
    },
  }
};
</script>

<style lang="scss" scoped>
.right-content {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
  
  .header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
  }
}

.notice-list {
  min-height: 200px;
}

.notice-item {
  display: flex;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;

  &.is-unread {
    background: #f5f7fa;
    border-color: #d9ecff;
  }

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  .notice-icon {
    width: 40px;
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    padding-top: 2px;
  }

  .notice-content {
    flex: 1;
    min-width: 0;

    .notice-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;

      .notice-title {
        font-size: 15px;
        font-weight: 500;
        color: #303133;
      }
    }

    .notice-text {
      font-size: 13px;
      color: #606266;
      line-height: 1.6;
      margin-bottom: 8px;
      word-break: break-word;
    }

    .notice-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #909399;

      .notice-type {
        padding: 2px 8px;
        background: #f4f4f5;
        border-radius: 4px;
      }
    }
  }
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.empty-tip {
  padding: 60px 0;
  text-align: center;
}
</style>
